import { Component, OnInit, Inject } from '@angular/core';
import { Utility } from '../../../../../common/utility';
import { DialogService } from '../../../../../shared/services/dialog.service';
import { FormBuilder } from '@angular/forms';
import { ModifyGroupTemplateComponent } from '../modify-group-template-popup.component';
import { MD_DIALOG_DATA, MdDialogRef } from '@angular/material';
import { ConsultationHistoryService } from '../../../../consultation-history/consultation-history.service';
import { OverviewInfo } from '../../../../../models/group-template-information/overview-info';
@Component({
  selector: 'app-group-template-information-popup',
  templateUrl: './group-template-information-popup.component.html',
  providers: [ConsultationHistoryService]
})
export class GroupTemplateInformationPopupComponent implements OnInit {
  title = 'Group Template Information';
  tabIndex = -1;
  tab = {
    overview: 0,
    travelAgenda: 1,
    recommendedDisease: 2,
    recommendedPrescription: 3,
    recommendedLabTest: 4,
    auditTrail: 5,
    attachment: 6
  };
  isLoadedTab = {
    overview: false,
    travelAgenda: false,
    recommendedDisease: false,
    recommendedPrescription: false,
    recommendedLabTest: false,
    auditTrail: false,
    attachment: false
  };
  groupId: string;
  countries: Array<any>;
  height: number;
  constructor(public utility: Utility,
    public dialogService: DialogService,
    private formBuilder: FormBuilder,
    public dialogRef: MdDialogRef<ModifyGroupTemplateComponent>,
    @Inject(MD_DIALOG_DATA) public data: { groupId: string, countries: Array<any>, height: number }) {
    if (this.data) {
      this.groupId = this.data.groupId;
      this.countries = this.data.countries;
      this.height = this.data.height ? (this.data.height > 600 ? this.data.height - 192 : this.data.height - 205) : null;
    }
    this.tabIndex = this.tab.overview;
    this.setLoadedTab();
  }

  ngOnInit() {
  }

  setLoadedTab() {
    switch (this.tabIndex) {
      case this.tab.overview:
        this.isLoadedTab.overview = true;
        break;
      case this.tab.travelAgenda:
        this.isLoadedTab.travelAgenda = true;
        break;
      case this.tab.recommendedDisease:
        this.isLoadedTab.recommendedDisease = true;
        break;
      case this.tab.recommendedLabTest:
        this.isLoadedTab.recommendedLabTest = true;
        break;
      case this.tab.recommendedPrescription:
        this.isLoadedTab.recommendedPrescription = true;
        break;
      case this.tab.attachment:
        this.isLoadedTab.attachment = true;
        break;
      case this.tab.auditTrail:
        this.isLoadedTab.auditTrail = true;
        break;
    }
  }

  changeTab(e) {
    this.tabIndex = e.index;
    this.setLoadedTab();
  }

  onCloseDialog() {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/waiting-room/group-template/group-template-information-popup/group-template-information-popup.component.ts